export default function wheelActivate() {
    const btn = document.querySelector('.wheel__spin');
    const sector = document.querySelector('.wheel__drum');
    const overlay = document.querySelector('.lp__overlay');
    const formBtn = document.querySelector('.form-btn');
    // const ticket = document.querySelector('.lp__ticket-img');
    const arrow = document.querySelector('.wheel__arrow');
    const overlayWheel = document.querySelector('.overlay');
    // const ticketHide = document.querySelector('.lp__ticket-hide');
    // const ticketShow = document.querySelector('.lp__ticket-show');
    // const ticketText = document.querySelector('.lp__ticket-text');
    // const ticketTitle = document.querySelector('.lp__header');

    btn.addEventListener('click', () => {
        sector.classList.add('active');
        sector.classList.remove('wheel_animate');
        arrow.classList.remove('arrow_animate');
        btn.classList.remove('spin_animate');

        dataLayer.push ({
            'event':'click_button',
            'button_name':'cta_1',
            'location':''
        })

        setTimeout(function() {
            overlayWheel.classList.add('show');
        }, 7500)

        setTimeout(function() {
            overlay.classList.add('display_flex');
            setTimeout(()=>{
                document.body.classList.add('overflow-hidden');
                overlay.classList.add('show');
            }, 500)
        }, 8500)
    });

    document.querySelector('#RegisterForm').addEventListener('submit', () => {
        const type = document.querySelector(`[data-value='phone']`).classList.contains('active') ? 'phone' : 'email';

        dataLayer.push ({
            'event':'registration',
            'step':'success',
            type,
            'location':'header'
        })
    })
}
